module.exports = __webpack_public_path__ + "static/media/icon-trophy.6c60210b.svg";